var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "#1F1B16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4999 22H22.7099L22.4299 21.73C23.6299 20.33 24.2499 18.42 23.9099 16.39C23.4399 13.61 21.1199 11.39 18.3199 11.05C14.0899 10.53 10.5299 14.09 11.0499 18.32C11.3899 21.12 13.6099 23.44 16.3899 23.91C18.4199 24.25 20.3299 23.63 21.7299 22.43L21.9999 22.71V23.5L26.2499 27.75C26.6599 28.16 27.3299 28.16 27.7399 27.75C28.1499 27.34 28.1499 26.67 27.7399 26.26L23.4999 22ZM17.4999 22C15.0099 22 12.9999 19.99 12.9999 17.5C12.9999 15.01 15.0099 13 17.4999 13C19.9899 13 21.9999 15.01 21.9999 17.5C21.9999 19.99 19.9899 22 17.4999 22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1dab3721c2f7d474b100429799a835dd.svg";
export { ForwardRef as ReactComponent };